// extracted by mini-css-extract-plugin
export default {"tooltip":"VV-z","arrow":"WV-z"};